import Vue from "vue";
import Login from "@/views/Login.vue";
import store from "@/store";

import VueRouter from "vue-router";
Vue.use(VueRouter);

let auth0_Roles = ["unLogin", "user", "admin"];
let auth1_Roles = ["user", "admin"];
let auth2_Roles = ["admin"];

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { authRoles: auth0_Roles },
  },
  {
    path: "/NavBar",
    name: "NavBar",
    component: () => import("../views/NavBar.vue"),
    meta: { authRoles: auth1_Roles },
    children: [
      {
        path: "Panel", // 修改为相对路径
        name: "Panel",
        component: () => import("../views/Panel/Panel.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "OestrusAlgorithm",
        name: "OestrusAlgorithm",
        component: () =>
          import("../views/Algorithm/estrus/EstrusAlgorithm.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "DiseaseAlgorithm",
        name: "DiseaseAlgorithm",
        component: () =>
          import("../views/Algorithm/disease/DiseaseAlgorithm.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "DashBoard",
        name: "DashBoard",
        component: () => import("../views/DashBoard.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ChangeAlgoAttr",
        name: "ChangeEstrusAttr",
        component: () =>
          import("../views/Algorithm/estrus/ChangeEstrusAttr.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ChangeDiseaseAlgoAttr",
        name: "ChangeDiseaseAttr",
        component: () =>
          import("../views/Algorithm/disease/ChangeDiseaseAttr.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Data/CheckValueError",
        name: "CheckValueError",
        component: () => import("../views/Data/CheckValueError.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "Data/Table",
        name: "Table",
        component: () => import("../views/Data/DataTable/DataTable.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "Data/Chart",
        name: "Chart",
        component: () => import("../views/Data/DataChart.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "Data/DataPieChart",
        name: "DataPieChart",
        component: () => import("../views/Data/DataPieChart.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "Data/Avg",
        name: "Avg",
        component: () => import("../views/Data/AvgChart.vue"),
        meta: { authRoles: auth1_Roles },
      },
      {
        path: "AlgorithmAttr",
        name: "AlgorithmAttr",
        component: () => import("@/views/Device/AlgorithmAttr.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "DeviceInfo",
        name: "DeviceInfo",
        component: () => import("@/views/Device/DeviceInfo.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "TimeInterval",
        name: "TimeInterval",
        component: () => import("@/views/Device/TimeInterval.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "TimeCalibration",
        name: "CheckValue",
        component: () => import("@/views/Device/TimeCalibration.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "LostBags",
        name: "LostBags",
        component: () => import("@/views/Device/LostBags.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ConvertToExcel",
        name: "ConvertToExcel",
        component: () => import("@/views/Device/ConvertToExcel.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "CheckDeviceInfo",
        name: "CheckDeviceInfo",
        component: () => import("@/views/Device/CheckDeviceInfo.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "CheckDeviceInfoLog",
        name: "CheckDeviceInfoLog",
        component: () => import("@/views/Device/CheckDeviceInfoLog.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Batch",
        name: "Batch",
        component: () => import("@/views/Device/Batch.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "DeviceID",
        name: "DeviceID",
        component: () => import("@/views/Device/DeviceID.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "IllBehave",
        name: "IllBehave",
        component: () => import("@/views/Device/IllegalBehavior.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "DeviceScan",
        name: "DeviceScan",
        component: () => import("@/views/Device/DeviceScan/index.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/Overview",
        name: "MonitorOverview",
        component: () => import("@/views/Monitor/SystemOverview.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/Observation",
        name: "MonitorObservation",
        component: () => import("@/views/Monitor/ObservationOverview.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/Devices",
        name: "MonitorDevices",
        component: () => import("@/views/Monitor/DeviceMonitor.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/PackLoss",
        name: "MonitorPackLoss",
        component: () => import("@/views/Monitor/PackLossMonitor.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/TableGrowth",
        name: "MonitorTableGrowth",
        redirect: "/NavBar/Monitor/TableGrowth/Data",
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/TableGrowth/Data",
        name: "MonitorTableGrowthData",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthData.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/TableGrowth/Config",
        name: "MonitorTableGrowthConfig",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthConfig.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/TableGrowth/Fields",
        name: "MonitorTableGrowthFields",
        redirect: "/NavBar/Monitor/TableGrowth/Data",
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Monitor/TableGrowth/History",
        name: "MonitorTableGrowthHistory",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthHistory.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Settings/Mail",
        name: "SettingsMail",
        component: () => import("@/views/Settings/MailManage.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "Settings/MailHistory",
        name: "SettingsMailHistory",
        component: () => import("@/views/Settings/MailHistory.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ClientPush/MqttClient",
        name: "MqttClientConfig",
        component: () => import("@/views/ClientPush/MqttClientConfig.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ClientPush/Config",
        name: "ClientPushConfig",
        component: () => import("@/views/ClientPush/ClientPushConfig.vue"),
        meta: { authRoles: auth2_Roles },
      },
      {
        path: "ClientPush/History",
        name: "ClientPushHistory",
        component: () => import("@/views/ClientPush/ClientPushHistory.vue"),
        meta: { authRoles: auth2_Roles },
      },
    ],
  },
  // 添加重定向规则，确保直接访问子路由也能正常工作
  {
    path: "/NavBar/:pathMatch(.*)*",
    redirect: (to) => {
      const userRole = store.state.role || "unLogin";
      if (userRole === "unLogin") return "/";
      return { path: to.path.replace(/^\/NavBar/, "") }; // 移除重复的 /NavBar
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 改进后的动态路由生成函数
function generateRoutes(routes, role) {
  return routes.filter((route) => {
    if (
      route.meta &&
      route.meta.authRoles &&
      !route.meta.authRoles.includes(role)
    ) {
      return false;
    }

    if (route.children) {
      route.children = generateRoutes(route.children, role);
      // 如果过滤后没有子路由，且没有重定向，则过滤掉该路由
      if (route.children.length === 0 && !route.redirect) {
        return false;
      }
    }

    return true;
  });
}

function refreshRouter() {
  const userRole = store.state.role || "unLogin";
  const newRoutes = generateRoutes(routes, userRole);

  // 避免重复添加路由
  if (router.matcher) {
    router.matcher = new VueRouter({
      mode: "hash",
      base: process.env.BASE_URL,
      routes: newRoutes,
    }).matcher;
  }
}

// 初始刷新路由
refreshRouter();
router.refreshRouter = refreshRouter;

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const userRole = store.state.role || "unLogin";
  const token = store.state.token;
  const requiresAuth = to.matched.some((record) => record.meta.authRoles);

  // 检查是否有 role 但无 token（视为未登录）
  if (userRole !== "unLogin" && !token) {
    store.dispatch("clearAuth");
    next("/");
    return;
  }

  if (requiresAuth && !to.meta.authRoles.includes(userRole)) {
    next("/");
  } else {
    next();
  }
});

export default router;
